import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = "https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=1200&q=80";

export const imgUrl = (p) => (!p ? FALLBACK : p.startsWith("http") ? p : `${API}/images/${p}`);

export const euro = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export const km = (n) => `${new Intl.NumberFormat("it-IT").format(n || 0)} km`;

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || "Si è verificato un errore";
};

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (method, url, data, config = {}) => {
      const token = await getToken();
      const res = await axios({
        method,
        url: `${API}${url}`,
        data,
        ...config,
        headers: { ...(config.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      });
      return res.data;
    },
    [getToken]
  );
}
